/**
 * SavedItemTitle — captured-item title row with optional duration and saved
 * check (ported from Noteble — ADR-022).
 */

import React from 'react';
import { Check, Clock } from 'lucide-react';

interface SavedItemTitleProps {
  label: string;
  index?: number;
  /** Duration in seconds — shown as MM:SS next to the title. */
  duration?: number;
  /** Show green check to indicate item is saved. Defaults to true. */
  saved?: boolean;
}

export const SavedItemTitle: React.FC<SavedItemTitleProps> = ({ label, index, duration, saved = true }) => (
  <div className="flex items-center gap-1.5">
    <p className="font-medium text-slate-900 dark:text-slate-100">{label}{index != null ? ` ${index + 1}` : ''}</p>
    {duration != null && (
      <span className="text-xs text-slate-400 dark:text-slate-500 font-mono flex items-center gap-0.5">
        <Clock className="w-3 h-3" />
        {Math.floor(duration / 60)}:{String(duration % 60).padStart(2, '0')}
      </span>
    )}
    {saved && <Check className="w-3.5 h-3.5 text-emerald-500 flex-shrink-0" />}
  </div>
);
